<template>
  <div class="row">
    <div class="col-md-8">
      <div class="card card-default">
        <service-wizard-layout
          title=""
          subtitle=""
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >
          <template v-slot:rental>
            <form novalidate data-vv-scope="rental">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                    'has-error': errors.has('rental.type'),
                    }"
                  >
                    <label>Type:</label>
                    <v-select
                    name="type"
                    placeholder="Select Type"
                    v-validate="'required'"
                    :value="filledInSaleDefinition.requiredObjs.equipmentrental.rentalType"
                    label="description"
                    :options="rentalTypeOptions"
                    @input="typeSelected"
                    >
                    </v-select>
                    <span class="has-error" v-if="errors.has('rental.type')">{{
                    errors.first("rental.type")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('rental.terms'),}">
                    <label class="control-label">Terms:</label>
                    <v-select
                      name="terms"
                      placeholder="Select Terms"
                      v-validate="'required'"
                      :value="filledInSaleDefinition.requiredObjs.equipmentrental.rentalTerms"
                      label="description"
                      :options="rentalTermOptions"
                      @input="termSelected"
                    ></v-select>
                    <!-- @input="termSelected" -->
                    <span class="has-error" v-if="errors.has('rental.terms')">{{
                      errors.first("rental.terms")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                <label class="text-warning" v-if="filledInSaleDefinition.requiredObjs.equipmentrental.rentalType === 'Basic Rental'">&nbsp; Billing will continue after terms are expired.</label>
                <label class="text-warning" v-else>&nbsp; Billing will stop after terms are expired.</label>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:billing>
            <form novalidate data-vv-scope="billing">
              <label class="control-label"><strong>Bill From</strong></label>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('billing.bill'),}">
                    <v-select
                      name="bill"
                      :options="periods"
                      placeholder="Select Billing From"
                      v-validate="'required'"
                      v-model="filledInSaleDefinition.requiredObjs.equipmentrental.billFrom"
                      :get-option-label="getLabel"
                    ></v-select>
                    <span class="has-error" v-if="errors.has('billing.bill')">{{
                      errors.first("billing.bill")
                    }}</span>
                  </div>
                </div>
              </div>
              <hr/>
              <label class="control-label"><strong>Billing Details</strong></label>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('billing.monthly'),}">
                    <label class="control-label">Monthly Instalment (excl. VAT):</label>
                    <input
                      type="text"
                      class="form-control"
                      name="monthly"
                      placeholder="Monthly Instalment"
                      v-validate="'required'"
                      v-model="filledInSaleDefinition.requiredObjs.equipmentrental.monthlyInstalmentExVat"
                    />
                    <span class="has-error" v-if="errors.has('billing.monthly')">{{
                      errors.first("billing.monthly")
                    }}</span>
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:equipment>
            <form novalidate data-vv-scope="equipment">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('equipment.name'),}">
                    <label class="control-label">Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      placeholder="Name"
                      v-validate="'required'"
                      v-model="filledInSaleDefinition.requiredObjs.equipmentrental.equipmentName"
                    />
                    <span class="has-error" v-if="errors.has('equipment.name')">{{
                      errors.first("equipment.name")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('equipment.model'),}">
                    <label class="control-label">Model:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="model"
                      placeholder="Model"
                      v-validate="'required'"
                      v-model="filledInSaleDefinition.requiredObjs.equipmentrental.equipmentModel"
                    />
                    <span class="has-error" v-if="errors.has('equipment.model')">{{
                      errors.first("equipment.model")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('equipment.serial'),}">
                    <label class="control-label">Serial:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="serial"
                      placeholder="Serial Number"
                      v-validate="'required'"
                      v-model="filledInSaleDefinition.requiredObjs.equipmentrental.equipmentSerialNumber"
                    />
                    <span class="has-error" v-if="errors.has('equipment.serial')">{{
                      errors.first("equipment.serial")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group" :class="{'has-error': errors.has('equipment.link'),}">
                    <label class="control-label">Link:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="link"
                      placeholder=""
                      v-model="filledInSaleDefinition.requiredObjs.equipmentrental.equipmentLink"
                    />
                    <span class="has-error" v-if="errors.has('equipment.link')">{{
                      errors.first("equipment.link")
                    }}</span>
                  </div>
                </div>
              </div>
            </form>
          </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";
import SaleFunctions from "@/pages/Services/SaleFunctions";

export default {
  extends: SaleFunctions,
  components: {
    ServiceWizardLayout,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parts: [
        {
          name: "rental",
          displayName: "Rental Package",
          icon: "fa fa-cubes",
        },
        {
          name: "billing",
          displayName: "Billing Information",
          icon: "fa fa-dollar",
        },
        {
          name: "equipment",
          displayName: "Equipment Details",
          icon: "fa fa-archive",
        },
      ],
      filledInSaleDefinition: {
        requiredObjs: {
          equipmentrental: {},
        },
        supportingEnums: {
          equipmentrental: {
            rentalType: {},
            rentalTerms: {}
          },
        },
      },
      periods: [],
      rentalTypeOptions: [],
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;

    for (let i = 0; i < this.filledInSaleDefinition.supportingEnums.equipmentrental.rentalType.length; i++) {
      this.rentalTypeOptions[i] = this.filledInSaleDefinition.supportingEnums.equipmentrental.rentalType[i].description;
    }

    this.filledInSaleDefinition.requiredObjs.equipmentrental.rentalType = "Basic Rental";
    this.filledInSaleDefinition.requiredObjs.equipmentrental.rentalTerms = "";
    this.filledInSaleDefinition.requiredObjs.equipmentrental.billFrom = "";
    this.filledInSaleDefinition.requiredObjs.equipmentrental.monthlyInstalmentExVat = "";

    this.$http
      .get(this.$config.aimsAPI + "system/billingperiods?max=" + 7)
      .then(
        (response) => {
          this.periods = response.data;
        },
        (error) => {
          this.showError("Error fetching billing periods", error);
          console.error(error);
        }
      );
  },
  computed: {
    //horrible, but how else, i don't have the full enum here (only name and description). investigate why.
    //pressed for time, so taking the easy way out. Will Typescript make this easier?
    rentalTermOptions() {
      const terms = this.filledInSaleDefinition?.supportingEnums?.equipmentrental?.rentalTerms;
      if (!terms) return [];
      const termsArray = Array.isArray(terms) ? terms : Object.values(terms);
      return [...termsArray].sort(
        (a, b) => this.rentalTermRank(a.description) - this.rentalTermRank(b.description)
      );
    } 
  },
  methods: {
    getLabel(period) {
      return this.prettifyBillingPeriod(period);
    },
    onComplete() {
        this.$emit("createSale", this.filledInSaleDefinition);
    },
    rentalTermRank(description) {
      switch (description) {
        case 'Monthly':
          return 1;
        case '6 Months':
          return 6;
        case '12 Months':
          return 12;
        case '24 Months':
          return 24;
        case '36 Months':
          return 36;
        default:
          return Number.MAX_SAFE_INTEGER; // unknown values sort last
      }
    },
    typeSelected(value) {
        for (let i = 0; i < this.filledInSaleDefinition.supportingEnums.equipmentrental.rentalType.length; i++) {
            if (value == this.filledInSaleDefinition.supportingEnums.equipmentrental.rentalType[i].description) {
                this.filledInSaleDefinition.requiredObjs.equipmentrental.rentalType = value;
            }
        }
    },
    termSelected(value) {
      //do we struggle like this with other enums as well?
      //Am I doing something wrong? Is this a can of worms, waiting to be opened?
      for (let i = 0; i < this.filledInSaleDefinition.supportingEnums.equipmentrental.rentalTerms.length; i++) {
        if (value === this.filledInSaleDefinition.supportingEnums.equipmentrental.rentalTerms[i]) {
              this.filledInSaleDefinition.requiredObjs.equipmentrental.rentalTerms = value.description;
        }
      }
      this.$validator.validate('rental.terms');  
    },
    validateStep(scope) {
      return this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>